<template>
  <div id="inicio">
    <v-container>
      <v-layout row wrap>
        <v-flex xs12>
          <v-img :src="require('../assets/logo_cctp.svg')" class="my-3" contain height="200"></v-img>
        </v-flex>
      </v-layout>
      <v-snackbar
        v-model="snack.state"
        top
        right
        :timeout="2500"
        :color="snack.color"
        :multi-line="snack.mode === 'multi-line'"
      >
        {{ snack.text }}
        <v-btn dark flat @click="snack.state = false">Cerrar</v-btn>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import Service from "../services/general";
import axios from "axios";
export default {
  name: "inicio",
  data: () => ({
    dialog: false,
    datos: [],
    snack: {
      state: false,
      color: "success",
      mode: "",
      timeout: 3000,
      text: ""
    }
  }),
  mounted() {},
  methods: {
    getDatos() {
      axios
        .get(Service.getBase() + "datos", Service.getHeader())
        .then(response => {
          this.datos = response.data;
        })
        .catch(error => {
          console.error("Error al cargar registros", error);
        });
    },
    
    showDialog() {
      this.mode = true;
      this.mdialog = true;
    },
    
    toast(color, text) {
      this.snack.color = color;
      this.snack.text = text;
      this.snack.state = true;
    }
  }
};
</script>